import { computed } from 'vue';
import { startCase, kebabCase } from 'lodash';

import { HomeServiceType, HomeServiceFrequency, HomeServiceOrderStatus, HomeServiceOrderProviderRole } from '@/models/homeService';

export const useHomeService = () => {
  const specialServiceLabels = {
    hvacServices: 'HVAC Services',
  };

  const serviceTypeList = computed(() =>
    Object.values(HomeServiceType).map((value: string, index: number) => ({
      id: index + 1,
      key: value,
      label: specialServiceLabels[value] ?? startCase(value),
    })),
  );

  const availableServiceTypeListToCreateUpdate = computed(() => {
    return serviceTypeList.value.filter((item) => item.key !== HomeServiceType.WantsGeneralInfo && item.key !== HomeServiceType.Caregiver);
  });

  const frequencyList = computed(() =>
    Object.values(HomeServiceFrequency).map((value: string, index: number) => {
      const kebabText = kebabCase(value);
      return {
        id: index + 1,
        key: value,
        label: kebabText.charAt(0).toUpperCase() + kebabText.slice(1),
      };
    }),
  );

  const statusList = computed(() =>
    Object.values(HomeServiceOrderStatus).map((value: string, index: number) => ({
      id: index + 1,
      key: value,
      label: startCase(value),
    })),
  );

  const providerRoleList = computed(() =>
    Object.values(HomeServiceOrderProviderRole).map((value: string, index: number) => ({
      id: index + 1,
      key: value,
      label: startCase(value),
    })),
  );

  return {
    serviceTypeList,
    availableServiceTypeListToCreateUpdate,
    frequencyList,
    statusList,
    providerRoleList,
  };
};
